import React from 'react';
import PropTypes from 'prop-types';

import { BlockDayInfo } from '../shared-component/block-day-info';

export const BlockDayComp = ({ blockDayEvent = {}, deleteBlockDayFn }) => {
  return (
    <div key={`block-day-${blockDayEvent.group_id}`}>
      <BlockDayInfo
        {...blockDayEvent}
        deleteBlockDayFn={deleteBlockDayFn}
        bufferTime={'buffer' === blockDayEvent.type}
      />
      <hr />
    </div>
  );
};


BlockDayComp.propTypes = {
  blockDayEvent: PropTypes.object,
  deleteBlockDayFn: PropTypes.func
};
